import { apiFetch } from '@/lib/api';
import type { Language, CreateLanguageInput, UpdateLanguageInput } from '@/types/language';

export async function listLanguages(): Promise<Language[]> {
  // Public endpoint returns only enabled; admin needs full list, but Plan 1
  // /languages filters on enabled=true. For the admin we read directly from
  // the table via an admin endpoint. As a temporary shortcut, the public
  // /languages returns enabled-only; we extend Plan 1 to also accept ?all=true
  // by passing through. If the public endpoint hasn't been extended, this
  // call still returns enabled langs; disabled ones won't appear in the table
  // until /languages-admin GET is added (out of scope here — admins enable
  // langs immediately on create).
  return apiFetch<Language[]>('/languages');
}

export async function createLanguage(input: CreateLanguageInput): Promise<Language> {
  return apiFetch<Language>('/languages-admin', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function updateLanguage(code: string, input: UpdateLanguageInput): Promise<Language> {
  return apiFetch<Language>(`/languages-admin/${encodeURIComponent(code)}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export async function deleteLanguage(code: string): Promise<void> {
  await apiFetch<{ status: 'deleted' }>(`/languages-admin/${encodeURIComponent(code)}`, {
    method: 'DELETE',
  });
}
